import React, { useEffect, useState } from 'react';
import cambioEstadoService from "../../services/cambioEstadoService";
import { obtenerSiguienteEstadoART } from "../../services/art/artEstadoService";
import EventoService from '../../services/eventoService';
import { toast } from "react-toastify";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PersonIcon from '@mui/icons-material/Person';
import PlaceIcon from '@mui/icons-material/Place';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { listarMedicos } from "../../services/medicoService";
import DatosMaestrosService from "../../services/datosMaestrosService";
import ComboboxDatosMaestros from "../../components/ComboboxDatosMaestros";
import BotonWhatsapp from '../../components/BotonWhatsapp';
import ModificarEventoModal from '../../components/ModificarEventoModal';

// Funciones auxiliares
const formatLocalFecha = (fechaInput) => {
    if (!fechaInput) return '';
    if (typeof fechaInput === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(fechaInput)) {
        return fechaInput;
    }
    const d = new Date(fechaInput);
    if (Number.isNaN(d.getTime())) return '';
    return new Date(d.getTime() - (d.getTimezoneOffset() * 60000)).toISOString().split('T')[0];
};

const parseLocalDate = (fechaInput) => {
    const fechaISO = formatLocalFecha(fechaInput);
    if (!fechaISO) return null;
    return new Date(`${fechaISO}T00:00:00`);
};

const obtenerFechaActual = () => formatLocalFecha(new Date());

const calcularHoraFin = (horaInicio, minutos) => {
    const [horas, mins] = horaInicio.split(':').map(Number);
    const totalMinutos = horas * 60 + mins + minutos;
    const nuevasHoras = Math.floor(totalMinutos / 60) % 24;
    const nuevosMinutos = totalMinutos % 60;
    return `${String(nuevasHoras).padStart(2, '0')}:${String(nuevosMinutos).padStart(2, '0')}`;
};

const formatearFecha = (fechaStr) => {
    const fecha = parseLocalDate(fechaStr);
    if (!fecha) return 'Fecha no disponible';
    return fecha.toLocaleDateString('es-AR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
};

// Componente formulario reutilizable
const FormularioReprogramar = ({ visible, datosTurno, setDatosTurno, cargando, medicos, cargandoMedicos, lugares, handleConfirmar, handleCancelar, motivoReprogramacion, setMotivoReprogramacion }) => {
    if (!visible) return null;

    return (
        <div className="mt-4">
            <h5 className="fw-semibold text-info mb-3">Reprogramar Turno Médico</h5>
            <div className="mb-3">
                <label className="form-label fw-semibold">Motivo de Reprogramación</label>
                <textarea className="form-control shadow-sm" rows="2" value={motivoReprogramacion} onChange={(e) => setMotivoReprogramacion(e.target.value)} placeholder="Indique el motivo de la reprogramación..." />
            </div>
            <div className="row g-3">
                <div className="col-md-6">
                    <label className="form-label fw-semibold">Nueva Fecha</label>
                    <div className="input-group">
                        <span className="input-group-text bg-light"><CalendarMonthIcon fontSize="small" /></span>
                        <input type="date" className="form-control shadow-sm" value={datosTurno.fecha} onChange={(e) => setDatosTurno({ ...datosTurno, fecha: e.target.value })} />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label fw-semibold">Nueva Hora</label>
                    <div className="input-group">
                        <span className="input-group-text bg-light"><AccessTimeIcon fontSize="small" /></span>
                        <input type="time" className="form-control shadow-sm" value={datosTurno.hora} onChange={(e) => setDatosTurno({ ...datosTurno, hora: e.target.value })} />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label fw-semibold">Médico</label>
                    <div className="input-group">
                        <span className="input-group-text bg-light"><PersonIcon fontSize="small" /></span>
                        <select className="form-select shadow-sm" value={datosTurno.idMedico} onChange={(e) => setDatosTurno({ ...datosTurno, idMedico: e.target.value })} disabled={cargandoMedicos}>
                            <option value="">Seleccionar médico...</option>
                            {medicos.map(medico => (
                                <option key={medico.idMedico} value={medico.idMedico}>
                                    {medico.nombre} {medico.apellido}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="col-md-6">
                    <ComboboxDatosMaestros
                        opciones={lugares.filter(l => l.tipo === 'Consultorio' || !l.tipo)}
                        valor={datosTurno.lugar}
                        onChange={(valor) => setDatosTurno({ ...datosTurno, lugar: valor })}
                        tipo="lugar"
                        tipoLugar="Consultorio"
                        placeholder="Seleccione o escriba un lugar..."
                        label="Lugar"
                        icon={PlaceIcon}
                    />
                </div>
            </div>
            <div className="d-flex justify-content-center gap-3 mt-4">
                <button className="btn btn-warning d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold" onClick={handleConfirmar} disabled={cargando || !datosTurno.fecha || !datosTurno.hora || !datosTurno.idMedico || !motivoReprogramacion.trim()}>
                    {cargando ? 'Reprogramando...' : <><EditCalendarIcon fontSize="small" /> Confirmar Reprogramación</>}
                </button>
                <button className="btn btn-outline-secondary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold" onClick={handleCancelar} disabled={cargando}>
                    Cancelar
                </button>
            </div>
        </div>
    );
};

function GestorTurnoMedico({ tramite, onAvanzar }) {
    const [cargando, setCargando] = useState(false);
    const [turnoInfo, setTurnoInfo] = useState(null);
    const [cargandoTurno, setCargandoTurno] = useState(false);
    const [medicos, setMedicos] = useState([]);
    const [cargandoMedicos, setCargandoMedicos] = useState(true);
    const [lugares, setLugares] = useState([]);
    const [mostrarReprogramar, setMostrarReprogramar] = useState(false);
    const [mostrarModificar, setMostrarModificar] = useState(false);
    const [motivoReprogramacion, setMotivoReprogramacion] = useState('');
    const [observaciones, setObservaciones] = useState('');
    const [datosTurno, setDatosTurno] = useState({
        fecha: obtenerFechaActual(),
        hora: '',
        idMedico: '',
        lugar: '',
        observaciones: ''
    });

    useEffect(() => {
        cargarMedicos();
        cargarLugares();
        cargarTurnoActual();
    }, []);

    const cargarMedicos = async () => {
        setCargandoMedicos(true);
        try {
            const medicosActivos = await listarMedicos(true);
            setMedicos(medicosActivos);
        } catch (error) {
            console.error('Error al cargar médicos:', error);
            toast.error('Error al cargar médicos');
        } finally {
            setCargandoMedicos(false);
        }
    };

    const cargarLugares = async () => {
        try {
            const response = await DatosMaestrosService.getLugares();
            setLugares(response.data || []);
        } catch (error) {
            console.error('Error al cargar lugares:', error);
        }
    };

    const cargarTurnoActual = async () => {
        setCargandoTurno(true);
        try {
            const response = await EventoService.getEventosPorTramite(tramite.idTramite);
            const eventos = response.data;
            const ultimoEventoTurno = eventos
                .filter(e => e.tipoEvento === 'Turno Médico')
                .pop();
            if (ultimoEventoTurno) {
                setTurnoInfo(ultimoEventoTurno);
            }
        } catch (error) {
            console.error("Error al cargar turno:", error);
        } finally {
            setCargandoTurno(false);
        }
    };

    const handleReprogramarTurno = async () => {
        if (!datosTurno.fecha || !datosTurno.hora || !datosTurno.idMedico) {
            toast.error('Debe seleccionar fecha, hora y médico');
            return;
        }

        if (!motivoReprogramacion.trim()) {
            toast.error('Debe indicar el motivo de la reprogramación');
            return;
        }

        const fechaSeleccionada = parseLocalDate(datosTurno.fecha);
        if (!fechaSeleccionada) {
            toast.error('La fecha del turno es invalida');
            return;
        }

        setCargando(true);
        try {
            // Eliminar evento anterior
            if (turnoInfo && turnoInfo.idEvento) {
                await EventoService.eliminarEvento(turnoInfo.idEvento);
            }

            // Crear nuevo evento
            const medicoSeleccionado = medicos.find(m => m.idMedico === parseInt(datosTurno.idMedico));
            const nombreMedico = medicoSeleccionado ? `${medicoSeleccionado.nombre} ${medicoSeleccionado.apellido}` : 'No especificado';

            const nuevoEvento = {
                titulo: `Turno Médico (Reprogramado) - ${tramite.cliente?.nombre || ''} ${tramite.cliente?.apellido || ''}`,
                descripcion: `Médico: ${nombreMedico} - Lugar: ${datosTurno.lugar || 'No especificado'} - Observación: ${datosTurno.observaciones || 'No especificadas'}`,
                lugar: datosTurno.lugar || null,
                fecha: formatLocalFecha(datosTurno.fecha),
                horaInicio: datosTurno.hora,
                horaFin: calcularHoraFin(datosTurno.hora, 60),
                todoElDia: false,
                tipoEvento: 'Turno Médico',
                idTramite: tramite.idTramite,
                visibilidad: 'POR_AREA',
                canalesNotificacion: {
                    whatsapp: false,
                    email: false,
                    inapp: true
                }
            };

            await EventoService.crearEvento(nuevoEvento);
            window.dispatchEvent(new CustomEvent('eventoCreadoDesdeChat', { detail: { timestamp: Date.now(), source: 'tramite' } }));

            const comentario = `Turno reprogramado\nMotivo: ${motivoReprogramacion}\nFecha: ${formatearFecha(datosTurno.fecha)}\nHora: ${datosTurno.hora}\nMédico: ${nombreMedico}`;
            await cambioEstadoService.cambiarEstado(tramite.idTramite, {
                idEstado: tramite.idEstadoActual,
                comentario: comentario
            });

            toast.success('Turno reprogramado correctamente');
            setMostrarReprogramar(false);
            setMotivoReprogramacion('');
            cargarTurnoActual();
        } catch (error) {
            console.error('Error al reprogramar turno:', error);
            toast.error('Error al reprogramar: ' + error.message);
        } finally {
            setCargando(false);
        }
    };

    const handleNoAsistio = async () => {
        setCargando(true);
        try {
            const siguienteEstado = await obtenerSiguienteEstadoART(tramite.nombreEstadoActual, 'Ingreso del trámite');
            const comentario = 'El cliente no asistió al turno médico programado. Se requiere reprogramación.';
            await cambioEstadoService.cambiarEstado(tramite.idTramite, {
                idEstado: siguienteEstado.id,
                comentario: comentario
            });
            toast.success('Registrado: Cliente no asistió. Avanzando al siguiente estado.');
            onAvanzar();
        } catch (error) {
            toast.error('Error: ' + error.message);
        } finally {
            setCargando(false);
        }
    };

    const handleGuardarModificacionEvento = async (idEvento, eventoActualizado) => {
        try {
            await EventoService.modificarEvento(idEvento, eventoActualizado);
            setMostrarModificar(false);
            await cargarTurnoActual();
            toast.success('Turno actualizado correctamente');
        } catch (error) {
            console.error('Error al modificar turno ART:', error);
            toast.error('No se pudo actualizar el turno');
        }
    };

    if (cargandoTurno) {
        return <div className="alert alert-info">Cargando detalles del turno...</div>;
    }

    if (!turnoInfo) {
        return <div className="alert alert-warning">No se encontraron detalles del turno asignado.</div>;
    }

    const descripcion = turnoInfo.descripcion || '';
    const extraerCampoDescripcion = (texto, etiquetas) => {
        if (!texto) return null;
        for (const etiqueta of etiquetas) {
            const regex = new RegExp(`${etiqueta}\\s*:\\s*(.*?)(?:\\s-\\s|$)`, 'i');
            const match = texto.match(regex);
            if (match && match[1] && match[1].trim()) {
                return match[1].trim();
            }
        }
        return null;
    };

    const medicoExtraido = extraerCampoDescripcion(descripcion, ['Médico', 'Medico']);
    const lugarExtraido = extraerCampoDescripcion(descripcion, ['Lugar']);
    const observacionesExtraidas = extraerCampoDescripcion(descripcion, ['Observación', 'Observacion']);

    const fechaTurno = formatearFecha(turnoInfo.fecha);
    const horaTurno = turnoInfo.horaInicio || 'No especificada';
    const nombreMedico = medicoExtraido || 'No especificado';
    const lugarTurno = (turnoInfo.lugar && turnoInfo.lugar.trim()) || lugarExtraido || 'No especificado';
    const observacionesTurno = observacionesExtraidas || 'No especificadas';

    return (
        <div className="card shadow-lg border-0 rounded-4 p-4 mb-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="fw-bold text-success mb-0">
                    Turno Médico Asignado
                </h4>
                <span className="badge bg-success rounded-pill px-3 py-2">
                    <EventAvailableIcon fontSize="small" className="me-1" />
                    Turno Confirmado
                </span>
            </div>

            {/* Tarjeta de detalle del turno */}
            <div className="card bg-light border-0 rounded-3 p-4 mb-3">
                <h5 className="fw-semibold text-secondary mb-3">
                    Detalles del Turno
                </h5>

                <div className="row g-3">
                    <div className="col-md-6">
                        <div className="d-flex align-items-center">
                            <CalendarMonthIcon fontSize="small" className="text-primary me-2" />
                            <div>
                                <small className="text-muted d-block">Fecha</small>
                                <strong className="text-dark">{fechaTurno}</strong>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="d-flex align-items-center">
                            <AccessTimeIcon fontSize="small" className="text-primary me-2" />
                            <div>
                                <small className="text-muted d-block">Hora</small>
                                <strong className="text-dark">{horaTurno.slice(0, 5)}</strong>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="d-flex align-items-center">
                            <PersonIcon fontSize="small" className="text-primary me-2" />
                            <div>
                                <small className="text-muted d-block">Médico</small>
                                <strong className="text-dark">{nombreMedico}</strong>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="d-flex align-items-center">
                            <PlaceIcon fontSize="small" className="text-primary me-2" />
                            <div>
                                <small className="text-muted d-block">Lugar</small>
                                <strong className="text-dark">{lugarTurno}</strong>
                            </div>
                        </div>
                    </div>
                </div>

                {observacionesTurno && observacionesTurno !== 'No especificadas' && (
                    <div className="mt-3 p-3 bg-white rounded-3 border">
                        <small className="text-muted d-block mb-1">Observación:</small>
                        <small className="text-dark" style={{ whiteSpace: 'pre-line' }}>
                            {observacionesTurno}
                        </small>
                    </div>
                )}

                <div className="mt-3 d-flex gap-2">
                    <BotonWhatsapp
                        idEvento={turnoInfo?.idEvento}
                        numeroTelefono={tramite.cliente?.telefonoPropio || tramite.cliente?.telefono}
                        nombreCliente={`${tramite.cliente?.nombre || ''} ${tramite.cliente?.apellido || ''}`.trim()}
                        contactosAdicionales={tramite.cliente?.contactos}
                        fechaTurno={turnoInfo?.fecha}
                        horaTurno={turnoInfo?.horaInicio || turnoInfo?.hora}
                        lugar={lugarTurno}
                        tipoEvento="Turno Médico"
                        tramiteId={tramite?.idTramite}
                        className="btn-sm"
                    />
                </div>
            </div>

            {!mostrarReprogramar ? (
                <>
                    <div className="d-flex flex-wrap justify-content-center gap-3">
                        <button
                            className="btn btn-warning d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                            onClick={() => setMostrarReprogramar(true)}
                            disabled={cargando}
                        >
                            <EditCalendarIcon fontSize="small" />
                            Reprogramar
                        </button>

                        {turnoInfo && (
                            <button
                                className="btn btn-secondary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                                onClick={() => setMostrarModificar(true)}
                                disabled={cargando}
                                title="Corregir error de tipeo sin generar cambio de estado"
                            >
                                <EditCalendarIcon fontSize="small" />
                                Modificar Turno
                            </button>
                        )}

                        <button
                            className="btn btn-danger d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                            onClick={handleNoAsistio}
                            disabled={cargando}
                        >
                            <EventBusyIcon fontSize="small" />
                            No Asistió
                        </button>

                        <button
                            className="btn btn-success d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                            onClick={async () => {
                                setCargando(true);
                                try {
                                    const siguienteEstado = await obtenerSiguienteEstadoART(tramite.nombreEstadoActual);
                                    const comentario = `Turno completado. Cliente evaluado por el médico.${observaciones.trim() ? ' Observaciones: ' + observaciones : ''}`;
                                    await cambioEstadoService.cambiarEstado(tramite.idTramite, {
                                        idEstado: siguienteEstado.id,
                                        comentario: comentario
                                    });
                                    toast.success('Turno registrado como completado. Avanzando al siguiente estado.');
                                    onAvanzar();
                                } catch (error) {
                                    toast.error('Error: ' + error.message);
                                } finally {
                                    setCargando(false);
                                }
                            }}
                            disabled={cargando}
                        >
                            <CheckCircleIcon fontSize="small" />
                            Turno Completado
                        </button>
                    </div>

                    {/* --- SECCIÓN DE OBSERVACIONES --- */}
                    <div className="mt-4 p-3 bg-light rounded-3 border">
                        <h6 className="fw-semibold text-primary mb-3">Observaciones</h6>
                        <textarea
                            className="form-control shadow-sm"
                            rows="3"
                            placeholder="Agregue observaciones o comentarios sobre el turno médico..."
                            value={observaciones}
                            onChange={(e) => setObservaciones(e.target.value)}
                            maxLength="500"
                        />
                        <small className="text-muted mt-1 d-block">
                            {observaciones.length}/500 caracteres - Este comentario quedará registrado en el historial al avanzar de estado.
                        </small>
                    </div>
                </>
            ) : (
                <FormularioReprogramar
                    visible={true}
                    datosTurno={datosTurno}
                    setDatosTurno={setDatosTurno}
                    cargando={cargando}
                    medicos={medicos}
                    cargandoMedicos={cargandoMedicos}
                    lugares={lugares}
                    handleConfirmar={handleReprogramarTurno}
                    handleCancelar={() => {
                        setMostrarReprogramar(false);
                        setMotivoReprogramacion('');
                        setDatosTurno({ fecha: obtenerFechaActual(), hora: '', idMedico: '', lugar: '', observaciones: '' });
                    }}
                    motivoReprogramacion={motivoReprogramacion}
                    setMotivoReprogramacion={setMotivoReprogramacion}
                />
            )}

            {turnoInfo && (
                <ModificarEventoModal
                    isOpen={mostrarModificar}
                    onClose={() => setMostrarModificar(false)}
                    evento={{...turnoInfo, tieneAsistenciaMedica: true}}
                    onSave={handleGuardarModificacionEvento}
                />
            )}
        </div>
    );
}

export default GestorTurnoMedico;

